import template from './filterWithDropdownView.html';
import { FilterWithDropdownController } from './filterWithDropdownController';
export const FilterWithDropdownComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: FilterWithDropdownController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        title: '@?',
        label: '@?',
        placeholder: '@?',
        options: '<',
        chips: '<',
        handleFilter: '&?',
    },
};
